module.exports = __webpack_public_path__ + "static/img/bg_admission.bd0d98e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_admission.jpg
// module id = Np6Z
// module chunks = 1